import { Component, OnInit } from '@angular/core';
import { RepositoryService } from "../../shared/services/repository.service";
import { RiskUser } from './../../_interfaces/RiskUser.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { DatePipe } from '@angular/common'
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements OnInit {
  userDetail: RiskUser;
  userDetailsForm: FormGroup;
  submitted = false;

  constructor(private formBuilder: FormBuilder,
    private repository: RepositoryService,
    private router: Router,
    private activeRoute: ActivatedRoute) { }

  ngOnInit() {
    this.userDetailsForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      surname: ['', Validators.required],
      email: ['', Validators.required],
      admin: ['', Validators.required],
      superAdmin: [''],
      dormant: [''],
      financialAccess: [''],
      strategicAccess: [''],
      riskEventAccess: [''],
    });

    this.getUserDetails();
  }

  get f() { return this.userDetailsForm.controls; }

  getUserDetails() {
    let id: string = this.activeRoute.snapshot.params['id'];
    let apiUrl: string = `Users/${id}`;

    this.repository.getData(apiUrl)
      .subscribe(res => {
        this.userDetail = res as RiskUser;
        this.f.firstname.setValue(this.userDetail.firstname);
        this.f.surname.setValue(this.userDetail.surname);
        this.f.email.setValue(this.userDetail.email);
        this.f.admin.setValue(+ this.userDetail.admin);
        this.f.superAdmin.setValue(this.userDetail.superAdmin);
        this.f.dormant.setValue(this.userDetail.dormant);
        this.f.financialAccess.setValue(this.userDetail.financialAccess);
        this.f.strategicAccess.setValue(this.userDetail.strategicAccess);
        this.f.riskEventAccess.setValue(this.userDetail.riskEventAccess); 
      });
  }

  updateUserFromForm() {
    this.userDetail.firstname = this.f.firstname.value
    this.userDetail.surname = this.f.surname.value;
    this.userDetail.email = this.f.email.value;

    //if (this.f.admin.value) {
      this.userDetail.admin = + this.f.admin.value;
    //}
    //if (this.f.superAdmin.value) {
      this.userDetail.superAdmin = + this.f.superAdmin.value;
    //}
    //if (this.f.dormant.value) {
      this.userDetail.dormant = + this.f.dormant.value;
    //}
    this.userDetail.financialAccess = + this.f.financialAccess.value;
    this.userDetail.strategicAccess = + this.f.strategicAccess.value;
    this.userDetail.riskEventAccess = + this.f.riskEventAccess.value;

  }

  saveUserDetails() {
    let apiAddress: string = `Users`;

    this.repository.update(apiAddress, this.userDetail)
      .subscribe(res => {
        // this.riskDetail = res as RiskUser;
        //this.router.navigate(["../../risks"], { relativeTo: this.activeRoute });
        this.router.navigate([`/myrisks/risk-users`]);
      }, error => {
        //console.error("Error: ", error);
        alert('Error:!' + error.message + '\n\n');
          this.router.navigate([`/myrisks/risk-users`]);
      },
        () => this.router.navigate([`/myrisks/risk-users`])
      );
  }

  onSubmit() {
    this.submitted = true;
    this.updateUserFromForm();
    this.saveUserDetails();
  }

  onCancelForm() {
    this.submitted = false;
    let userUrl: string = `/myrisks/risk-users`;
    this.router.navigate([userUrl]);
  }

  // --
}
